import { ButtonBaseProps, Popover } from "@mui/material";
import { usePopoverActions } from "app/hooks/popover/usePopoverActions";
import { useCallback, useState } from "react";

import { WorkspaceButton } from "./components/WorkspaceButton";
import { WorkspaceList } from "./components/WorkspaceList";
import { workspaces } from "./data";
import { Workspace } from "./types";

export type WorkspacesPopoverProps = ButtonBaseProps;

export function WorkspacesPopover(buttonProps: WorkspacesPopoverProps) {
  const [selectedWorkspace, setSelectedWorkspace] = useState(workspaces[0]);

  const { closePopover, openPopover, popoverElementAnchor } =
    usePopoverActions();

  const changeWorkspace = useCallback(
    (newValue: Workspace) => {
      setSelectedWorkspace(newValue);
      closePopover();
    },
    [closePopover],
  );

  return (
    <>
      <WorkspaceButton
        openPopover={openPopover}
        selectedWorkspace={selectedWorkspace}
        {...buttonProps}
      />
      <Popover
        anchorEl={popoverElementAnchor}
        onClose={closePopover}
        open={!!popoverElementAnchor}
      >
        <WorkspaceList
          changeWorkspace={changeWorkspace}
          selectedWorkspace={selectedWorkspace}
        />
      </Popover>
    </>
  );
}
